<div class="selected-job-cont">
  <div class="selected-job-action" (click)="deselectJob(true)">
    <awc-icon [icon]="icons.LEFT_ARROW"></awc-icon>
    <span>Back to jobs</span>
  </div>

  <ng-container *ngIf="page?.subsection === ConceptSubSection.COMPARISON_TOOL">
    <ng-container *ngIf="!jobsToCompare || jobsToCompare.length === 0; else comparisonJobsLoaded">
      <div class="loading-cont">
        <div class="label">Loading results...</div>
        <awc-icon [icon]="icons.SPINNER"></awc-icon>
        <awc-progress-bar
          [color]="colorBackground.SECONDARY_DEFAULT"
          [loading]="true"
        ></awc-progress-bar>
      </div>
    </ng-container>

    <ng-template #comparisonJobsLoaded>
      <div class="selected-job-item-cont">
        <awc-accordion
          *ngFor="let job of jobsToCompare"
          [label]="resultsService.getJobName(job.jobId)"
          [isOpen]="true">
          <div class="selected-job-item-cont">
            <ng-container *ngFor="let result of job.results;">
              <div
                class="selected-job-item"
                [ngClass]="{ 'selected-job-item-active': isCompareSelected(result.id), 'selected-job-item-disabled': isCompareSelectedOfDifferentType(result) }"
                (click)="onCompareResult(result, job)"
              >
                <awc-icon *ngIf="result.requirement_solved_type === resultType.DRIVE_CYCLE" [icon]="icons.ELECTRICAL" [color]="result.feasible ? 'green' : 'red'"></awc-icon>
                <awc-icon *ngIf="result.requirement_solved_type === resultType.DYNAMIC" [icon]="icons.ROCKET" [color]="result.feasible ? 'green' : 'red'"></awc-icon>
                <awc-icon *ngIf="result.requirement_solved_type === resultType.STATIC" [icon]="icons.PIN" [color]="result.feasible ? 'green' : 'red'"></awc-icon>
                <span>{{ result.requirement.name }}</span>
                <awc-icon *ngIf="result.requirement_solved_type === resultType.STATIC && result.capability_curve?.errors && Object.keys(result.capability_curve?.errors ?? {}).length > 0" [icon]="icons.WARNING" (click)="$event.stopPropagation(); onCapabilityCurveError(result)" [color]="colorBackground.SECONDARY_DEFAULT" class="requirement-warning-icon"></awc-icon>
                <awc-icon *ngIf="result.requirement_solved_type === resultType.DRIVE_CYCLE &&result.warnings &&Object.keys(result.warnings).length > 0" [icon]="icons.WARNING" (click)="onDriveCycleWarning(result)" [color]="colorBackground.SECONDARY_DEFAULT" class="requirement-warning-icon"></awc-icon>
              </div>
            </ng-container>
          </div>
        </awc-accordion>
      </div>
    </ng-template>
  </ng-container>

  <ng-container *ngIf="page?.subsection === ConceptSubSection.RESULTS">
    <ng-container *ngIf="!results || results.length === 0; else resultsLoaded">
      <div class="loading-cont">
        <div class="label">Loading results...</div>
        <awc-icon [icon]="icons.SPINNER"></awc-icon>
      </div>
    </ng-container>

    <ng-template #resultsLoaded>
      <div class="selected-job-item-cont">
        <ng-container *ngFor="let result of results;">
          <div class="selected-job-item" [ngClass]="selectedResult === result.id ? 'selected-job-item-active' : ''" (click)="selectResult(result)">
            <awc-icon *ngIf="result.requirement_solved_type === resultType.DRIVE_CYCLE" [icon]="icons.ELECTRICAL" [color]="result.feasible ? 'green' : 'red'"></awc-icon>
            <awc-icon *ngIf="result.requirement_solved_type === resultType.DYNAMIC" [icon]="icons.ROCKET" [color]="result.feasible ? 'green' : 'red'"></awc-icon>
            <awc-icon *ngIf="result.requirement_solved_type === resultType.STATIC" [icon]="icons.PIN" [color]="result.feasible ? 'green' : 'red'"></awc-icon>
            <span>{{ result.requirement.name }}</span>
            <awc-icon *ngIf="result.requirement_solved_type === resultType.STATIC && result.error_code" [icon]="icons.WARNING" [color]="colorBackground.SECONDARY_DEFAULT" class="requirement-warning-icon"></awc-icon>
            <awc-icon *ngIf="result.requirement_solved_type === resultType.DYNAMIC && result.error_code" [icon]="icons.WARNING" [color]="colorBackground.SECONDARY_DEFAULT" class="requirement-warning-icon"></awc-icon>
            <awc-icon *ngIf="result.requirement_solved_type === resultType.STATIC && result.capability_curve?.errors && Object.keys(result.capability_curve?.errors ?? {}).length > 0" [icon]="icons.WARNING" (click)="$event.stopPropagation(); onCapabilityCurveError(result)" [color]="colorBackground.SECONDARY_DEFAULT" class="requirement-warning-icon"></awc-icon>
            <awc-icon *ngIf="result.requirement_solved_type === resultType.DRIVE_CYCLE && result.warnings && Object.keys(result.warnings).length > 0" [icon]="icons.WARNING" (click)="onDriveCycleWarning(result)" [color]="colorBackground.SECONDARY_DEFAULT" class="requirement-warning-icon"></awc-icon>
          </div>
        </ng-container>
      </div>
    </ng-template>
  </ng-container>
</div>
